import { render, staticRenderFns } from "./payroute.vue?vue&type=template&id=21af9a34&"
import script from "./payroute.vue?vue&type=script&lang=js&"
export * from "./payroute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports